'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var ATTACHED = exports.ATTACHED = 'attached';
var DETACHED = exports.DETACHED = 'detached';
var FAILED = exports.FAILED = 'failed';


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/conversations-internal-pub-sub/static-1.4265/js/ably/constants/channelStates.js
// module id = 407
// module chunks = 2 3